import React from 'react';
import {observer} from 'mobx-react';
import {AlertModal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const UnshareRevieweeModal = observer(({reviewee, onClose, onSubmit, isOpen}) => {
  return (
    <AlertModal
      isOpen={isOpen}
      onHide={onClose}
      size='md'
      header='performance_reviews.view.Unshare'
    >
      <div className='space-y-2'>
        <FormattedMessage
          id='performance_reviews.view.UNSHARE_REVIEWEE_DESCRIPTION'
          values={{revieweeName: _.get(reviewee, 'employee.name')}}
        />
      </div>
      <ModalButtons
        saveCaption='performance_reviews.view.Unshare'
        onSave={() => onSubmit()}
        onCancel={onClose}
      />
    </AlertModal>
  );
});

export default UnshareRevieweeModal;
